
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { ContactInfoData, ContactInfoMethods, ContactInfoComputed, ContactInfoProps } from './ContactInfo';
import { componentMode } from './Footer.config';

export default ComponentInitializeDispatcher.extend<
  ContactInfoData,
  ContactInfoMethods,
  ContactInfoComputed,
  ContactInfoProps
>({
  name: 'owc-contact-info',
  props: {
    contactInfo: {
      type: Object,
    },
  },
  computed: {
    isEdit: function(): boolean {
      return componentMode.isEditMode;
    },
    title: function(): string | undefined {
      return this.isEdit ? this.componentData?.title : this.contactInfo?.title;
    },
    text: function(): string {
      return this.isEdit ? this.componentData?.text : this.contactInfo?.text;
    },
  },
  mounted() {
    const selectContact = (this.$refs.contact as HTMLElement).querySelector('a');
    selectContact?.classList.add('owc-footer-contact-info__contact');
  },
});
